import { ALL_BOT_TYPE } from './constants';
import { firstInitStore } from '@/stores';

export function shouldApplyLiveAgentAvailbility() {
  return (
    firstInitStore?.initStore?.botType === ALL_BOT_TYPE.INTENT_BASE_BOT
    || firstInitStore?.initStore?.botType === ALL_BOT_TYPE.SELLER_BASE_BOT
  );
}
